import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import ReviewsPreview from '../components/ReviewsPreview';
import ContactForm from '../components/ContactForm';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <div className="home-content">
        <div className="home-main">
          <Services />
          <ReviewsPreview />
        </div>
        <div className="home-sidebar">
          <ContactForm isSidebar={true} />
        </div>
      </div>
    </div>
  );
};

export default Home;
